var map = {
	"./ar": 1631,
	"./ar.js": 1631,
	"./cs": 1632,
	"./cs.js": 1632,
	"./da": 1633,
	"./da.js": 1633,
	"./de": 1634,
	"./de.js": 1634,
	"./el": 1635,
	"./el.js": 1635,
	"./en-gb": 1636,
	"./en-gb.js": 1636,
	"./es": 1637,
	"./es.js": 1637,
	"./fr": 1638,
	"./fr-ca": 1639,
	"./fr-ca.js": 1639,
	"./fr.js": 1638,
	"./hu": 1640,
	"./hu.js": 1640,
	"./it": 1641,
	"./it.js": 1641,
	"./ja": 1642,
	"./ja.js": 1642,
	"./ko": 1643,
	"./ko.js": 1643,
	"./pl": 1644,
	"./pl.js": 1644,
	"./pt": 1645,
	"./pt-br": 1646,
	"./pt-br.js": 1646,
	"./pt.js": 1645,
	"./ru": 1647,
	"./ru.js": 1647,
	"./tl-ph": 1648,
	"./tl-ph.js": 1648,
	"./vi": 1649,
	"./vi.js": 1649,
	"./zh-cn": 1650,
	"./zh-cn.js": 1650,
	"./zh-tw": 1651,
	"./zh-tw.js": 1651
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2856;